type FormattersKey = 'fullFormat'


export const dateFormats:Record<FormattersKey,string> = {
  fullFormat: 'DD.MM.YYYY HH:mm:ss'
}
